import { render, staticRenderFns } from "./SingleReport.vue?vue&type=template&id=7663b3b8&"
import script from "./SingleReport.vue?vue&type=script&lang=js&"
export * from "./SingleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports